<template>
    <section>
        <div class="flex flex-wrap -mx-2">
            <div class="w-full px-2 md:w-2/3">
                <h1>👋 {{$t('message.welcome_in_app')}}</h1>
                <p>
                    {{$t('message.welcome_in_app_paragraph')}}
                </p>
                <form  @submit.prevent="submit">
                    <div class="form-group" :class="{'text-red-600': errors.name === 'ERROR', 'text-success' : errors.name === 'OK'}">
                        <label>{{$t('message.organization_name')}}</label>
                        <input name="name" @input="validate" type="text" v-model="organization.name" class="form-control" :class="{'border-red-500': errors.name === 'ERROR', 'border-green-500': errors.name === 'OK'}">
                        <span v-if="errors.name === 'ERROR'" class="block text-sm text-red-600">{{$t('message.name_required')}}.</span>
                    </div>
                    <div class="form-group">
                        <label>{{$t('message.timezone')}}</label>
                        <select class="form-control" v-model="organization.timezone">
                            <option v-for="timezone in timezones" :key="timezone.id" :value="timezone.id">{{timezone.name}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>{{$t('message.currency')}}</label>
                        <select class="form-control" v-model="organization.currency">
                            <option v-for="code in currencyCodes()" :key="code" :value="code">{{code}}</option>
                        </select>
                    </div>
                    <div class="flex flex-wrap -mx-2">
                        <div class="w-full px-2 md:w-1/2">
                            <div class="form-group" :class="{'text-red-600': errors.pricePerLiterCold === 'ERROR', 'text-success' : errors.pricePerLiterCold === 'OK'}">
                                <label>{{$t('message.price_estimate_cold_water')}}</label>
                                <div class="flex flex-wrap items-center gap-2">
                                    <input type="number" step="any" min="0" name="cold_price" v-model="organization.pricePerLiterCold" class="form-control" :class="{'border-red-500': errors.pricePerLiterCold === 'ERROR', 'border-green-500': errors.pricePerLiterCold === 'OK'}"> Kč / Litr
                                </div>
                            </div>
                        </div>
                        <div class="w-full px-2 md:w-1/2">
                            <div class="form-group" :class="{'text-red-600': errors.pricePerLiterHot === 'ERROR', 'text-success' : errors.pricePerLiterHot === 'OK'}">
                                <label>{{$t('message.price_estimate_hot_water')}}</label>
                                <div class="flex flex-wrap items-center gap-2">
                                    <input type="number" step="any" min="0" name="hot_price" v-model="organization.pricePerLiterHot" class="form-control" :class="{'border-red-500': errors.pricePerLiterHot === 'ERROR', 'border-green-500': errors.pricePerLiterHot === 'OK'}"> Kč / Litr
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap -mx-2">
                        <div class="w-full px-2 md:w-1/2">
                            <div class="form-group" :class="{'text-red-600': errors.pricePerUnit === 'ERROR', 'text-success' : errors.pricePerUnit === 'OK'}">
                                <label>{{$t('message.price_estimate_heat')}}</label>
                                <div class="flex flex-wrap items-center gap-2">
                                    <input type="number" step="any" min="0" name="heat_price" v-model="organization.pricePerUnit" class="form-control" :class="{'border-red-500': errors.pricePerUnit === 'ERROR', 'border-green-500': errors.pricePerUnit === 'OK'}"> {{organization.currency}} / {{$t('message.heat_units')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary">{{$t('message.create')}}</button>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import {ORGANIZATION_REQUEST, TIMEZONE_REQUEST} from '../_store'
    import mixins from '../modules/mixins'
    import cc from 'currency-codes'

    export default {
        name: 'Create',
        mixins: [mixins],
        data () {
            return {
                organization: {
                    name: '',
                    pricePerLiterHot: 0.1,
                    pricePerLiterCold: 0.1,
                    pricePerUnit: 1,
                    currency: 'CZK',
                    timezone: 'Europe/Prague',
                    action: 'create'
                },
                timezones: [],
                errors: {
                    name: '',
                    pricePerLiterHot: '',
                    pricePerLiterCold: '',
                    pricePerUnit: ''
                }
            }
        },
        methods: {
            submit (e) {
                e.preventDefault()
                this.validate()
                if (this.errors.name === 'OK') {
                    return this.$store.dispatch(ORGANIZATION_REQUEST, this.organization)
                        .then(() => {
                            return this.$router.replace('/')
                        })
                        .catch(err => {
                            this.notify('danger', err.message)
                        })
                }
            },
            validate () {
                if (!this.organization.name) {
                    this.errors.name = 'ERROR'
                } else {
                    this.errors.name = 'OK'
                }
                if (isNaN(Number(this.organization.pricePerLiterHot))) {
                    this.errors.pricePerLiterHot = 'ERROR'
                } else {
                    this.errors.pricePerLiterHot = 'OK'
                }
                if (isNaN(Number(this.organization.pricePerLiterCold))) {
                    this.errors.pricePerLiterCold = 'ERROR'
                } else {
                    this.errors.pricePerLiterCold = 'OK'
                }
                if (isNaN(Number(this.organization.pricePerUnit))) {
                    this.errors.pricePerUnit = 'ERROR'
                } else {
                    this.errors.pricePerUnit = 'OK'
                }
            },
            currencyCodes () {
                return cc.codes()
            }
        },
        created () {
            this.$store.dispatch(TIMEZONE_REQUEST)
                .then(resp => {
                    this.timezones = resp.data.timezones
                })
        }
    }
</script>

<style scoped>

</style>
